import React from 'react';
import './pageTitle.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title } from 'chart.js';
import { Pie, Line } from 'react-chartjs-2';
import { Chart } from "react-google-charts";




ChartJS.register(ArcElement, Tooltip, Legend);

export const grower_data = [
    ["Element", "Contracted Ha:", { role: "style" }],
    ["Manicaland", 450, "#b87333"], // RGB value
    ["Mashonaland East", 500, "silver"], // English color name
    ["Mashonaland Central", 750, "rgb(37, 150, 190)"],
    ["Masvingo", 50, "rgb(193, 0, 189)"],
    ["Midlands", 50, "rgb(4, 107, 200)"],
    ["Harare", 100, "rgb(107, 84, 52)"],
    ["Mashonaland West", 600, "rgb(217, 128, 1)"], // CSS-style declaration
];

export const data = {
    labels: ['Mashonaland West', 'Mashonaland East', 'Mashonaland Central', 'Manicaland', 'Harare', 'Midlands'],
    datasets: [
        {
            label: 'Loans Total',
            data: [150000, 100000, 158000, 150000, 200000, 100000],
            backgroundColor: [
                'rgb(37, 150, 190)',
                'rgb(193, 0, 189)',
                'rgb(4, 107, 200)',
                'rgb(107, 84, 52)',
                'rgb(0, 232, 253)',
                'rgb(217, 128, 1)',
            ],
            borderColor: [
                'rgb(37, 150, 190)',
                'rgb(193, 0, 189)',
                'rgb(4, 107, 200)',
                'rgb(107, 84, 52)',
                'rgb(0, 232, 253)',
                'rgb(217, 128, 1)',
            ],
            borderWidth: 1,
        },
    ],
};


function PageTitle() {



  return (

    <div className='pagetitle'>
      <h1 className='heading navbar-expand-lg navbar-light bg-light card_2'>Dashboard</h1>
      <nav>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item'>
            {/* <a href="/home">
              <i className='bi bi-house-door'></i>
            </a> */}

          </li>
          {/* <li className='breadcrumb-item active'>Dashboard</li> */}
          

        </ol>

      </nav>

      {/* <div class="card shadow p-3 mb-5 bg-body rounded">
          <div class="card-header">
            Featured
          </div>
          <div class="card-body">
            <h5 class="card-title">Special title treatment</h5>
            <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
            <a href="#" class="btn btn-primary">Go somewhere</a>
          </div>
      </div> */}
     {/* <div className='row'>

      <div className='card_1 col-sm-2 p-3 mb-5 bg-body rounded shadow'>
          <div className='card-header'>
            <b>Bales</b>
          </div>

        </div>

        <div className='card_1 col-sm-2 p-3 mb-5 bg-body rounded shadow'>
          <div className='card-header'>
           <b>Bales</b>
          </div>

        </div>

        <div className='card_1 col-sm-2 p-6 mb-5 bg-body rounded shadow'>
          <div className='card-header'>
           <b>Bales</b>
           <div class="card-body">

           </div>
          </div>

        </div>

        <div className='card_1 col-sm-2 p-3 mb-5 bg-body rounded shadow'>
          <div className='card-header'>
            <b>Bales</b>
          </div>

        </div>
      

      </div> */}
<br />
    <div class="">
      <div class="row">
        <div class="col-md-3">
          <div class="card card-1">
              <div className="row">
                  <div className="col-7">
                      <h5><i className='bi bi-people-fill icon-green'></i> Growers</h5>
                  </div>
                  <div className="col-3">
                      <h5><i className='bi bi-people-fill icon-green'></i></h5>
                  </div>
              </div>
            <br/>
            <div class="d-flex align-items-center">
              <div className="row">
                  <div className="col">
                      <p className="mb-0 text-secondary">Contracted Growers</p>
                      <h6 className="my-1 text-info"><b>1200</b></h6>
                  </div>
              </div>
                <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto">
                    <p class="mb-0 text-secondary">Contracted Hectares</p>
                    <h6 class="my-1 text-info"><b>1,800</b></h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-2">
            <h5><i className='bi bi-cash-coin icon-mass'></i> Loans</h5>
            <div class="d-flex align-items-center row">
              <div className="col">
                <p class="mb-0 text-secondary">Total</p>
                <h6 class="my-1 text-info"><b>$1,000,000</b></h6>
              </div>
              <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto col">
                  <p class="mb-0 text-secondary">Recovered</p>
                    <h6 class="my-1 text-info"><b>$800,000</b></h6>
              </div>
                <div className="col">
                    <p className="mb-0 text-secondary">Percentage</p>
                    <h6 className="my-1 text-info"><b>80%</b></h6>
                </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-3">
            <h5><i class="bi bi-receipt-cutoff icon-value"></i> Warehouse</h5>
              <br/>
            <div class="d-flex align-items-center row">
              <div className="col">
                <p class="mb-0 text-secondary">Disbursed Trucks</p>
                <h6 class="my-1 text-info"><b>68</b></h6>
              </div>
              <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto col">
                  <p class="mb-0 text-secondary">Disbursed Regions</p>
                    <h6 class="my-1 text-info"><b>7</b></h6>
              </div>
            </div>
            
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-4">
            <h5><i class='bi bi-leaf-fill'></i>      Agronomy</h5>
            <div class="d-flex align-items-center row">
              <div className="col">
                    <p class="mb-0 text-secondary">F.O</p>
                    <h6 class="my-1 text-info"><b>50</b></h6>
              </div>
              <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto col">
                  <p class="mb-0 text-secondary">Area Managers</p>
                  <h6 class="my-1 text-info"><b>10</b></h6>
              </div>
            </div>
              <div className="row">
                  <div className="col">
                      <p className="mb-0 text-secondary">Regions</p>
                      <h6 className="my-1 text-info"><b>6</b></h6>
                  </div>
                  <div className="col">
                      <p className="mb-0 text-secondary">Districts</p>
                      <h6 className="my-1 text-info"><b>56</b></h6>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>

        <br/>
        <br/>
        <br/>

        <div className="row">
            <div className='col-sm-6'>
                <h5 className="card_2">Loans Overview    <i className="bi bi-pie-chart"></i></h5>
               <div className="card_2">
                   <div>
                       <Pie data={data} />
                   </div>
               </div>
            </div>

            <div className='col-sm-6'>
                <div className="">
                    <h5 className="card_2">Agronomy Overview   <i className="bi bi-graph-down-arrow"></i></h5>
                    <div className="card_2" style={{ height: '315px' }}>
                        <Chart chartType="ColumnChart" width="100%" height="100%" data={grower_data} />

                    </div>
                </div>
            </div>
        </div>

        <br/>
        <br/>
        <br/>

        <div className='card_2'>

            <h5><b>Start-Off-Days </b>    <i className="bi bi-door-open"></i></h5>

            <div className='table table-responsive' data-bs-spy="scroll" style={{ maxHeight: "300px",
                    overflowY: "auto" }}>

            <table className='table table-striped'>
                    <thead style={{ position: "sticky", 
                    top: "0" }} className='card_10'>
                    <th>Id</th>
                    <th>F.Officer</th>
                        <th>Created Date</th>
                        <th>Time</th>
                        <th>YTD Grower Visited</th>
                        <th>YTD Visits</th>
                        <th>Visits Per Day</th>
                        <th>Distance(Kms)</th>
                        <th>BT Start(%)</th>
                        <th>BT End(%)</th>
                        <th>BT Report(%)</th>
                        <th>Hours Worked</th>
                    </thead><br />
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>tmaduuro</td>
                            <td>15-05-2025</td>
                            <td>07:00:15</td>
                            <td>145</td>
                            <td>180</td>
                            <td>15</td>
                            <td>180</td>
                            <td>70</td>
                            <td>25</td>
                            <td>30</td>
                            <td>25</td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </div>



    <br />




        <div className='card_2'>

            <h5><b>F.Officer Loan Info </b> <i className="bi bi-wallet2"></i></h5>

            <div className='table table-responsive' data-bs-spy="scroll" style={{ maxHeight: "300px",
                overflowY: "auto" }}>

                <table className='table table-striped'>
                    <thead style={{ position: "sticky",
                        top: "0" }} className='card_10'>
                    <th>Id</th>
                    <th>F.Officer</th>
                    <th>Area Manager</th>
                    <th>Region</th>
                    <th>Grower Contracted</th>
                    <th>Contracted Ha</th>
                    <th>Loan Total(Usd$)</th>
                    <th>Recovered Total(Usd$)</th>
                    <th>Recovery(%)</th>
                    <th>Not-Recovered Total(Usd$)</th>
                    <th>Not-Recovered(%)</th>
                    <th>Zero Deliveries</th>
                    </thead><br/>
                    <tbody>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>Magamba</td>
                        <td>Manicaland</td>
                        <td>145</td>
                        <td>180</td>
                        <td>150000</td>
                        <td>120000</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>tmaduuro</td>
                        <td>15-05-2025</td>
                        <td>07:00:15</td>
                        <td>145</td>
                        <td>180</td>
                        <td>15</td>
                        <td>180</td>
                        <td>70</td>
                        <td>25</td>
                        <td>30</td>
                        <td>25</td>
                    </tr>

                    </tbody>
                </table>
            </div>
        </div>

    

  </div>
        
  );



};

// document.getElementById('selectAllCheckbox')
//       .addEventListener('change', function () {
//     let checkbox =
//     document.querySelectorAll('.form-check-input');
//     checkbox.forEach(function (checkbox) {
//     checkbox.checked = this.checked;
//     }, this);
//     });

export default PageTitle;